import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO, ADDRESS, SITE_CONFIG, SOCIAL_MEDIA } from '../../data/constants';
import Navigation from '../Navigation/Navigation';
import './Header.css';

const Header: React.FC = () => {
  const [isContactExpanded, setIsContactExpanded] = useState(false);

  return (
    <header className="header">
      {/* Top utility bar */}
      <div className="header-utility">
        <div className="container">
          <div className="utility-content">
            <div className="utility-left">
              <span className="utility-text">Profesjonalna fizjoterapia w Reczu</span>
            </div>
            <div className="utility-right">
              <div className="utility-contact">
                <a href={`tel:${CONTACT_INFO[0].phone.replace(/\s/g, '')}`} className="phone-link">
                  <i className="fas fa-phone"></i>
                  {CONTACT_INFO[0].phone}
                </a>
                <span className="divider">|</span>
                <a href={`tel:${CONTACT_INFO[1].phone.replace(/\s/g, '')}`} className="phone-link">
                  {CONTACT_INFO[1].phone}
                </a>
                <span className="divider">|</span>
                <a href={SOCIAL_MEDIA[0].url} target="_blank" rel="noopener noreferrer" className="facebook-link">
                  <i className={SOCIAL_MEDIA[0].icon}></i>
                  <span>Facebook</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Navigation />

      {/* Main header */}
      <div className="header-main">
        <div className="container">
          <div className="header-content">
            {/* Logo and brand */}
            <div className="header-brand">
              <div className="logo-container">
                <Link to="/" className="logo-link">
                  <img src={SITE_CONFIG.logo} alt="Fizjofit logo" className="logo" />
                </Link>
              </div>
              <div className="brand-info">
                <Link to="/" className="brand-link">
                  <p className="brand-title">{SITE_CONFIG.title}</p>
                  <p className="brand-subtitle">{SITE_CONFIG.subtitle}</p>
                </Link>
              </div>
            </div>

            {/* Contact and location */}
            <div className="header-contact">
              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="contact-details">
                  <span className="contact-label">Adres</span>
                  <span className="contact-value">{ADDRESS.street}, {ADDRESS.city}</span>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fas fa-clock"></i>
                </div>
                <div className="contact-details">
                  <span className="contact-label">Godziny otwarcia</span>
                  <span className="contact-value">Pon-Pt 8:00-19:00</span>
                </div>
              </div>

              <div className="contact-actions">
                <button 
                  className="contact-toggle"
                  onClick={() => setIsContactExpanded(!isContactExpanded)}
                  aria-label="Pokaż kontakt"
                >
                  <i className="fas fa-phone"></i>
                  <span>Kontakt</span>
                  <i className={`fas fa-chevron-${isContactExpanded ? 'up' : 'down'}`}></i>
                </button>
                
                <a href={SITE_CONFIG.mapUrl} target="_blank" rel="noopener noreferrer" className="map-link">
                  <i className="fas fa-directions"></i>
                  <span>Dojazd</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Expanded contact panel */}
      {isContactExpanded && (
        <div className="contact-panel">
          <div className="container">
            <div className="contact-panel-content">
              <div className="contact-cards">
                {CONTACT_INFO.map((contact, index) => (
                  <div key={index} className="contact-card">
                    <div className="contact-card-header">
                      <i className="fas fa-user-md"></i>
                      <h3>{contact.name}</h3>
                    </div>
                    <div className="contact-card-body">
                      <a href={`tel:${contact.phone.replace(/\s/g, '')}`} className="contact-phone">
                        <i className="fas fa-phone"></i>
                        {contact.phone}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
              <div className="contact-cards">
                <div className="info-item">
                  <div className="contact-card-header">
                    <i className="fas fa-map-marker-alt"></i>
                    <h3>Adres gabinetu</h3>
                  </div>
                  <div className="contact-card-body">
                    <div className="contact-address">
                      <i className="fas fa-map-marker-alt"></i>
                      <span>{ADDRESS.postalCode} {ADDRESS.city}</span>
                    </div>
                    <div className="contact-address">
                      <i className="fas fa-building"></i>
                      <span>{ADDRESS.street}</span>
                    </div>
                  </div>
                </div>
                <div className="info-item">
                  <div className="contact-card-header">
                    <i className="fas fa-clock"></i>
                    <h3>Godziny przyjęć</h3>
                  </div>
                  <div className="contact-card-body">
                    <div className="contact-hours">
                      <i className="fas fa-calendar-day"></i>
                      <span>Poniedziałek - Piątek: 8:00 - 19:00</span>
                    </div>
                    <div className="contact-hours">
                      <i className="fas fa-calendar-week"></i>
                      <span>Sobota: 9:00 - 13:00</span>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
